import { render, staticRenderFns } from "./ImeiResmi.vue?vue&type=template&id=c2aecf88&"
import script from "./ImeiResmi.vue?vue&type=script&lang=js&"
export * from "./ImeiResmi.vue?vue&type=script&lang=js&"
import style0 from "./ImeiResmi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports